<template>
	<transition name="slide-fade">
		<div>
			<b-row class="mt-2 ,b-3">
				<b-col xl="3" md="3" sm="12">
					<b-form-select
						hidden="true"
						id="period"
						v-model="usersForm.group"
						:options="groupOption"
						value-field="key"
						size="sm"
						class="mt-2"
						text-field="label"
						@change="selectGroupList(usersForm.group)"
					></b-form-select>
				</b-col>
				<b-col xl="7" md="7" sm="12"></b-col>
				<b-col xl="2" md="2" sm="12" class="text-right">
					<b-button
						size="sm"
						variant="success"
						class="mt-2 mb-3"
						v-b-modal.add-short-codes
						v-b-tooltip.hover
						title="Add User"
					>
						<i class="fas fa-plus"></i> New
					</b-button>
				</b-col>
			</b-row>
			<div class="text-center w-100">
				<b-icon
					icon="three-dots"
					class="text-center"
					animation="cylon"
					font-scale="4"
					v-if="loadingStatus"
				></b-icon>
			</div>

			<div class="mb-3" v-if="!loadingStatus">
				<b-row>
					<b-col cols="12" xl="8" lg="7" md="7" sm="6">
						<b-form-group
							label=""
							label-for="per-page-select"
							label-cols-sm="0"
							label-cols-md="0"
							label-cols-lg="0"
							label-align-sm="center"
							label-size="sm"
							class="mb-2 per-page-select"
						>
						<label for="per-page-select" class="mr-2 text-sm mt-1 mr-4">Show</label>
						<b-form-select
							id="per-page-select"
							class="diameter-report-select"
							v-model="perPage"
							:options="pageOptions"
							size="sm"
							v-on:input="changePageOption(perPage)"
						></b-form-select>
						</b-form-group>
					</b-col>
					<b-col cols="12" xl="4" lg="5" md="5" sm="6" class="customer-table-select">
						<b-form-group
							label=""
							label-for="filter-input"
							label-align-sm="right"
							label-size="sm "
							class="mb-0 per-page-select"
						>
							<label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
							<b-input-group size="sm">
								<b-form-input id="filter-input2" v-model="filter" class="mb-4"></b-form-input>
							</b-input-group>
						</b-form-group>
					</b-col>
				</b-row>
				<b-table
					striped
					hover
					:items="tableData"
					:fields="tableColumns"
					:current-page="currentPage"
					:per-page="perPage"
					:filter="filter"
					:filter-included-fields="filterOn"
					:sort-by.sync="sortBy"
					:sort-desc.sync="sortDesc"
					:sort-direction="sortDirection"
					head-variant="light"
					table-class="text-nowrap"
					class="data-management-table primary-table"
					sticky-header="true"
					thead-class="white"
					show-empty
					responsive
					small
					@filtered="onFiltered"
				>
					<template #cell(action)="row">
						<!-- <span v-if="!row.item.group.includes('PORTAL_ADMIN')" class="nowrap"> -->
							<i
								class="fas fa-pen-nib mr-3 cursor-pointer text-success"
								v-b-modal.edit-short-codes
								v-on:click="ChangeShortCodeFunc(row.item)"
								v-b-tooltip.hover
								title="Edit User"
							></i>
							<i
								class="fas fa-trash-alt mr-3 cursor-pointer text-danger"
								v-on:click="deleteShortCodes(row.item.dialed)"
								v-b-tooltip.hover
								title="Delete NSIM GT"
							></i>
						<!-- </span> -->
					</template>
					<template #cell(group)="row">
						<!-- <span v-if="!row.item.group.includes('PORTAL_ADMIN')"> -->
							<tags-input
								input-id="tags-pills"
								v-model="row.item.group"
								:userName="row.item.userName"
								tag-type="danger"
								size="sm"
								no-add-on-enter
								no-outer-focus
								v-on:click="removeUserFromGroup(row.item.userName, tag)"
							>
							</tags-input>
						<!-- </span> -->
						<!-- <span v-else>
							<b-badge variant="info">Portal Administrator</b-badge>
						</span> -->
					</template>
				</b-table>
				<b-row class="mt-4">
					<b-col >
						<p class="ml-3 nowrap">{{ startPage() }} - {{ lastPage() }} of {{ totalRows }}</p>
					</b-col>
					<b-col >
						<b-pagination
							class="flex-fill-custom pr-4 ml-3 justify-content-end"
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
							size="sm"
						></b-pagination>
					</b-col>
				</b-row>
			</div>
			<b-modal
				centered
				size="lg"
				id="add-short-codes"
				hide-footer
				title="Add New Short Code"
				class="Add-Short-Codes"
				cancel-title="Close"
				ok-variant="primary"
				ok-title="Submit"
			>
				<ShortCodesAdd :update="false"></ShortCodesAdd>
			</b-modal>
			<b-modal
				centered
				size="lg"
				id="edit-short-codes"
				hide-footer
				title="Edit Short code"
				class="Edit-Short-Codes"
				cancel-title="Close"
				ok-variant="primary"
				ok-title="Submit"
			>
				<ShortCodesAdd :update="true"></ShortCodesAdd>
			</b-modal>
		</div>
	</transition>
</template>
<script>
import productManagementService from "../../../../common/api-services/product-management-service";
import ShortCodesAdd from "../../../Components/ProductManagement/ShortCodes/ShortCodesAdd";
import swal from "sweetalert2";
import handleResponse from "../../../../common/directive/handlResponse";
import TagsInput from "@/components/Inputs/TagsInput";
import pagination from '../../../../common/format/pagination'

export default {
	name: "NsimList",
	components: {TagsInput, ShortCodesAdd},
	data() {
		return {
			show: "Show Data",
			usersForm: {
				group: [], //'Select Group',
			},
			groupOption: [],
			loadingStatus: false,
			totalRows: 0,
			currentPage: 1,
			pageOptions: [10, 25, 50, 100],
			perPage: 10,
			tableColumns: [
				{key: "action", label: "", sortDirection: "desc"},
        {key: "dialed", label: "Dialed", sortable: true, sortDirection: "desc"},
        {key: "carrier", label: "Carrier", sortable: true, sortDirection: "desc"},
        {key: "carrier_code", label: "Carrier Code", sortable: true, sortDirection: "desc"}
			],
			tableData: [],
			localData: [],
			sortBy: "",
			sortDesc: false,
			sortDirection: "asc",
			filter: null,
			filterOn: [],
		};
	},
	mounted() {
		this.getShortCodeFunc();

		this.$root.$on("getShortCodeFunc", () => {
			this.getShortCodeFunc();
		});

		this.$root.$on("removeUserFromGroup", res => {
			if (res.toString().includes(",")) {
				res = res.toString().split(",");
				this.removeUserFromGroup(res[0], res[1]);
			}
		});
	},
	methods: {
		removeUserFromGroup(username, group) {
			//console.log('remove user called...',username,' ',group);
			productManagementService.removeUserFromGroup(username, group).then(res => {
				let {type, msg} = handleResponse.apiResponse(res.data.message);
				this.$toast(msg, {type: type})
			});
		},

		changePageOption(page) {
			this.getTotalRows();
		},

		getShortCodeFunc() {
			this.tableData = [];
			this.loadingStatus = true;
			productManagementService.getShortCodes().then(res => {
				this.loadingStatus = false;
				if (res) {
					res.map(item => {
						let child = {
							carrier: item.carrier,
							carrier_code: item.carrier_code,
							dialed: item.dialed,
						};
						this.tableData.push(child);
					});
					this.localData = this.tableData;
					this.totalRows = this.tableData.length;
				} else {
					this.localData = [];
					this.totalRows = 0;
				}
				this.getTotalRows()
			});
		},

		getTotalRows() {
			if (this.perPage > this.totalRows) {
				this.fromPage = this.totalRows;
			} else {
				this.fromPage = this.perPage;
			}
		},
		startPage() {
		   return pagination.startPageFunc(this.currentPage, this.perPage)
		}, 
		lastPage() {
			return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows)
		},

		selectGroupList(list) {
			this.tableData = this.localData;
			// if (list === 'Select Group') {
			//   this.tableData = this.localData;
			// } else {
			let newChild = [];
			this.tableData.map(item => {
				if (item.group === list) {
					newChild.push(item);
				}
			});
			this.tableData = newChild;
			//}
			this.totalRows = this.tableData.length;
			this.paginationChanged(this.currentPage);
		},

		ChangeShortCodeFunc(user) {
			setTimeout(() => {
				//show the Change-User.vue modal
				this.$root.$emit("ChangeShortCodeOldData", user);
			});
		},

		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
      	},

		deleteShortCodes(dialed) {
			swal.fire({
				title: `Nsim`,
				text: `Delete selected Short Code? ${dialed}`,
				buttonsStyling: false,
				showCloseButton: true,
				showCancelButton: true,

				confirmButtonText: "Delete",
				confirmButtonClass: "btn btn-danger",

				cancelButtonText: "Cancel",
				cancelButtonClass: "btn btn-info",
			}).then(result => {
				if (result.isConfirmed) {
					productManagementService.deleteShortCodes(dialed).then(res => {
						let {type, msg} = handleResponse.apiResponse(res);
						this.$toast(msg, {type: type})
						this.getShortCodeFunc();
					});
				}
			});
		},

	},
	
};
</script>
